import { render, staticRenderFns } from "./OutgoingMessages.vue?vue&type=template&id=54575c86"
import script from "./OutgoingMessages.vue?vue&type=script&lang=js"
export * from "./OutgoingMessages.vue?vue&type=script&lang=js"
import style0 from "./OutgoingMessages.vue?vue&type=style&index=0&id=54575c86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports